<template>
  <div
    :class="[
      'page-loader',
      {
        'page-loader--loading': loading
      }
    ]"
  >
    <transition name="fade-out-in" mode="out-in">
      <div v-if="loading" key="loader" class="page-loader__loader">
        <b-spinner label="Loading" />
      </div>

      <div v-else key="content" class="page-loader__content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PageLoader',
  props: {
    loading: Boolean
  }
}
</script>

<style lang="scss">
.page-loader {
  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
